<template lang="pug">
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Top',
  methods: {
    ...mapActions([
      'SAVE_LOGOUT_AUTH'
    ]),
    logout () {
      this.SAVE_LOGOUT_AUTH()
      this.$router.push({path: '/login'})
    }
  },
  mounted: function () {
    this.logout()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/users/logout.vue